import { FC } from "react"
import { PartnershipPage as PartnershipPageContent } from "../../../components/LandingPage/PartnershipPage"

export const LandingPartnershipPage: FC = () => {
  return <PartnershipPageContent />
}
